var path = 'app/scripts/modules/core/src/widgets/notifier/notifier.component.html';
var html = "<div class=\"user-notifications user-notifications-top\">\n  <user-notification ng-repeat=\"message in $ctrl.messages\"\n                     message=\"message\"\n                     position=\"top\"\n                     dismiss=\"$ctrl.dismiss($index)\"></user-notification>\n</div>\n<div class=\"user-notifications user-notifications-bottom\">\n  <user-notification ng-repeat=\"message in $ctrl.messages\"\n                     message=\"message\"\n                     position=\"bottom\"\n                     dismiss=\"$ctrl.dismiss($index)\"></user-notification>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/widgets/notifier/notifier.component.html
// module id = 1091
// module chunks = 0